<template>
<div>
    <div class="yt-container">
      <div class="player-container">
        <div ref="player"></div>
      </div>
      <div class="toolbar" >
        <ui-icon icon="times" class="close" @click.native="close()"/>
      </div>
    </div>
  </div>
</template>

<script>
import UiIcon from '../../components/UiIcon.vue';
import YoutubePlayer from 'youtube-player'

export default {
  name: 'yt-player',
  props: ['youtubeId'],
  data:function(){
    return {
     element:undefined,
     playing:false,
     player:undefined,
    }
  },
  components:{
    UiIcon,
  },
  methods:{
    close:function(){
      this.$emit("close");
    },
    addPlayer(){
      var opts={
          height: '9',
          width: '16',
          videoId: this.youtubeId,
          controls:0,
          enablejsapi:1,
          allowfullscreen:0,
          playsinline:1,
      }
      var el=this.$refs['player'];
      this.player = new YoutubePlayer(el,opts);

   
    },
    removePlayer(){
      this.player.destroy();
      this.player=null;
    },
  },
  beforeDestroy(){
    this.removePlayer();
  },
  mounted:function(){
   this.addPlayer();
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yt-container{

  z-index:200000;
  position:fixed;
  background-color:rgba(0,0,0,.3);
  display:flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  
}
.player-container{
  position:relative;
  flex:1;
}
.toolbar{
  text-align:right;
 position:relative;
 background-color:#000000;
 padding:10px;
}
.close{
  cursor:pointer;
  font-size:1.5em;
}



</style>
